import React from 'react';

import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';

import './SkuSettingsGearButton.scss';

const { block, element } = bem('sku-settings-gear-button');

const SkuSettingsGearButton = ({ ariaLabel, className, onClick }) => (
  <button type="button" className={block({}, className)} aria-label={ariaLabel} onClick={onClick}>
    <Isvg src={ICONS.cog} className={element('icon')} />
  </button>
);

SkuSettingsGearButton.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default SkuSettingsGearButton;
